import PrivateRoutes from './PrivateRoutes'

export default PrivateRoutes
